import {createSelector} from '@ngrx/store';

import * as fromCitizenServicesProcedureSteps from './citizens-services-delivery-procedure-steps.reducer';
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromCitizenServicesProcedureSteps.citizensServicesDeliveryProcedureStepsesFeatureKey]);

export const selectCitizenServiceDeliveryProcedureSteps = createSelector(currentState, fromCitizenServicesProcedureSteps.selectAll);

export const selectTotalCitizenServiceDeliveryProcedureSteps = createSelector(currentState, fromCitizenServicesProcedureSteps.selectTotal);

export const selectModifiedServiceDeliveryProcedureSteps = createSelector(selectCitizenServiceDeliveryProcedureSteps, (citizens) => {
  return citizens.map((citizen) => {
    return {
      ...citizen
    };
  });
});
